import { SupportedLocale } from '@percent/cause-dashboard/common/hooks/useLocale/useLocale'

export type CreateAccountParams = {
  inviteId: string
  password: string
  preferredLanguage?: SupportedLocale
  marketingConsent?: boolean
}

export type OrganisationData = {
  id: string
  inviterEmail: string
  organisationName: string
  logo?: string
  organisationWebsite?: string
}

export enum NextAction {
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  SIGN_IN = 'SIGN_IN'
}

export type AcceptInviteResponse = {
  nextAction: NextAction
  data: OrganisationData
}

export type CreateAccountResponse = {
  accountId: string
  email: string
}
